import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const PodProjectBillReportConfig: ReportConfigBase = {
  type: EReportTypes.PodProjectBill,
  endpoint: "pod/invoices",
  filtersBase: [],
  summaryBase: [],
  columnsBase: Columns,
  withSelection: true,
  intro: {
    description: "Fulfillment bills for this print-on-demand project",
    url: "https://help.commonsku.com/knowledge/",
  },
};

export default PodProjectBillReportConfig;
